export default __webpack_public_path__ + "assets/1BrownCatSelected1.gif";